import { ObjectField, Test, TestType } from "../../parser/models/all.js";
import { isModule } from "../../parser/utils/moduleUtils.js";
import { getTitle, hasTitle } from "../../parser/utils/testTitleUtils.js";
import { PreProcessContext } from "../models/preProcessContext.js";
import { getChildGroupName, processChildObjectFields } from "./preProcessUtils.js";

/**
 * Processor for identifying JavaScript modules (ESM) and extracting tests from their exports.
 * 
 * @param field - The object field containing the module.
 * @param index - Field index in the collection.
 * @param context - The pre-processing context.
 * @returns True if the field was processed as a module.
 */
export function processModule(field: ObjectField, index: number, context: PreProcessContext): boolean {
  const { name, value } = field;

  if (isModule(value)) {
    const options = context.options;
    const type = TestType.MODULE;
    const isModuleWithTitle = hasTitle(value, options);

    const nameOrTitle = isModuleWithTitle
      ? getTitle(value, options) as string
      : name;

    const moduleTestGroup = new Test(
      field.groupName,
      nameOrTitle,
      value,
      new TestType(type),
      // test cases
      [],
      // only expression
      ""
    );

    context.tests.push(moduleTestGroup);

    // process children
    const testProps = processChildObjectFields(
      getChildGroupName(moduleTestGroup.groupName, nameOrTitle),
      value,
      options
    );

    context.tests.push(
      ...testProps
    );

    return true;
  }

  return false;
}
